import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`若昂 羅沙工作於艾格文(Xebia)。若昂是一位策略軟體交付顧問,他專注於協助團隊和組織在軟體產品方面做出策略型決策;對齊團隊和軟體,藉此優化價值流。他相信協作的力量並且他也是一位虛擬協作工具的熱衷者。`}</p>
    <p>{`當他不在崗位上,你可以發現他會與他的妻子和女兒一起去旅行,或者是躺在沙灘上閱讀書籍。若昂同樣是一位業餘廚師。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      